<template>
    <b-row>
        <div class="col-sm-5 mt-3">
            <label for="" class="form-label">Fecha inicial</label>
            <input type="date" class="form-control form-control-sm" v-model="fecha_inicial">
        </div>
        <div class="col-sm-5 mt-3">
            <label for="" class="form-label">Fecha final</label>
            <input type="date" class="form-control form-control-sm" v-model="fecha_final">
        </div>
        <div class="col-sm-2 mt-5">
            <button type="button" class="btn btn-sm btn-outline-dark btn-block"
                @click="obtener_resultados">Buscar</button>
        </div>
        <div class="col-sm-12 mt-3">
            <table class="table table-sm table-striped table-bordered" style="font-size: 10px;">
                <thead>
                    <tr>
                        <th style="width: 10%;text-align: center;">
                            ID
                        </th>
                        <th style="width: 60%;">
                            Sucursal
                        </th>
                        <th style="width: 15%;text-align: center;">
                            Cnt. Fac
                        </th>
                        <th style="width: 15%;text-align: center;">
                            Total
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in resultados" :key="index">
                        <td style="text-align: center;">
                            {{ item.sucursal }}
                        </td>
                        <td>
                            {{ item.nombre_sucursal }}
                        </td>
                        <td style="text-align: center;">
                            {{ item.total_facturas }}
                        </td>
                        <td style="text-align: center;">
                            Q{{ parseFloat(item.total).toLocaleString(undefined, {
                                minimumFractionDigits: 2, maximumFractionDigits: 2
                            }) }}
                        </td>
                    </tr>
                    <tr>
                        <td>

                        </td>
                        <td>

                        </td>
                        <td style="text-align: center;font-weight: bold;">
                            Gran Total
                        </td>
                        <td style="text-align: center;font-weight: bold;">
                            Q{{ parseFloat(gran_total).toLocaleString(undefined, {
                                minimumFractionDigits: 2, maximumFractionDigits: 2
                            }) }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </b-row>
</template>

<script>
    import moment from 'moment';
    import { mapActions, mapState } from 'vuex';
    export default {
        name: 'Consolidado',
        computed: {
            ...mapState(['id_empresa_seleccionada'])
        },
        data() {
            return {
                fecha_final: moment(Date.now()).format('YYYY-MM-DD'),
                fecha_inicial: moment(Date.now()).format('YYYY-MM-DD'),
                resultados: [],
                gran_total: 0
            }
        },
        methods: {
            async obtener_resultados() {

                let f = {
                    api: `movimientos-cabeceras/q/consolidado?fi=${this.fecha_inicial}&ff=${this.fecha_final}&empresa=${this.id_empresa_seleccionada}`
                }

                let rc = await this.obtener_data(f)
                this.resultados = rc

                let t = 0

                for (let i = 0; i < rc.length; i++) {
                    const e = rc[i];

                    t += e.total

                }

                this.gran_total = t

            },
            ...mapActions(['obtener_data'])
        },
    }
</script>

<style></style>